'use strict';

angular.module('mean.foreman').factory('foremanPhaseService', ['$filter', '$q', 'toaster', '$window',
    function ($filter, $q, toaster, $window) {

        var setLotsTasks = function (type) {
            var lots = [];
            var tasks = [];

            _.each(type, function (item) {
                var inlist = $filter('filter')(lots, {
                    'number': item.lot
                }, true);

                if (inlist.length === 0) {
                    lots.push({
                        'number': item.lot,
                        'plan_code': item.plan_code
                    });
                }

                inlist = $filter('filter')(tasks, {
                    'number': item.task_code
                }, true);

                if (inlist.length === 0) {
                    tasks.push({
                        'number': item.task_code
                    });
                }
            });

            var obj = {
                lots: lots,
                tasks: tasks
            }

            return obj;
        };

        var removedMerged = function (list) {
            var ret = [];

            _.each(list, function (item) {
                if (!item.merged) {
                    ret.push(item);
                }
            });

            return ret;
        };

        var removeZeroQuantityItems = function (tasks) {
            var ret = []

            _.each(tasks, function (task) {
                if (task.bid_quantity > 0 || task.quantity > 0) {
                    ret.push(task);
                }
            });

            return ret;
        };

        //this is used when generating the pdf so the list
        //is not crazy large.
        var pdfRemoveZeroQuantityItems = function (tasks) {
            var ret = []

            _.each(tasks, function (task) {
                if (task.quantity > 0) {
                    ret.push(task);
                }
            });

            return ret;
        };

        var combineSimilarItems = function (tasks) {
            var temp_list = [];

            _.each(tasks, function (curr_mat) {
                (curr_mat.foreman_note) ?
                    curr_mat.foreman_note = curr_mat.foreman_note.trim() : curr_mat.foreman_note = '';
                (curr_mat.bid_note) ?
                    curr_mat.bid_note = curr_mat.bid_note.trim() : curr_mat.bid_note = '';
                (curr_mat.color_code) ?
                    curr_mat.color_code = curr_mat.color_code.trim() : curr_mat.color_code = '';

                var query = {
                    'lot': curr_mat.lot, 
                    'name': curr_mat.name,
                    'bid_note': curr_mat.bid_note,
                    'foreman_note': curr_mat.foreman_note,
                    'color_code': curr_mat.color_code
                }
                var inlist = $filter('filter')(temp_list, query, true);

                if (inlist.length === 0) {
                    temp_list.push(curr_mat);
                } else if (inlist.length === 1) {
                    inlist[0].bid_quantity += Number(curr_mat.bid_quantity.toFixed(8));
                    inlist[0].quantity += Number(curr_mat.quantity.toFixed(8));
                } else {
                    toaster.pop('error', 'Material Combining Error', 'Contact Admin');
                    return;
                }
            });

            return temp_list;
        };

        var combineSimilarNoteItems = function (mats) {
            var temp_list = [];
            _.each(mats, function (curr_mat) {
                var inlist = $filter('filter')(temp_list, {
                    'name': curr_mat.name,
                    'note': curr_mat.note
                }, true);

                if (inlist.length === 0) {
                    temp_list.push(curr_mat);
                } else if (inlist.length === 1) {
                    inlist[0].bid_quantity += curr_mat.bid_quantity;
                    inlist[0].quantity += curr_mat.quantity;
                } else {
                    var one_found = 0;
                    _.each(inlist, function (mat) {
                        if (mat.note === curr_mat.note) {
                            inlist[0].bid_quantity += Number(curr_mat.bid_quantity.toFixed(8));
                            inlist[0].quantity += Number(curr_mat.quantity.toFixed(8));
                            one_found++;
                        }
                    });
                    if (one_found > 1) {
                        toaster.pop('error', 'Material Combining Error', 'Contact Admin');
                        return;
                    }
                }
            });
            return temp_list;
        };

        var combineSimilarNoteItemsNewArray = function (mats) {
            var temp_list = [];
            _.each(mats, function (curr_mat) {
                var inlist = $filter('filter')(temp_list, {
                    'name': curr_mat.name,
                    'note': curr_mat.note
                }, true);

                if (inlist.length === 0) {
                    temp_list.push(angular.copy(curr_mat));
                } else if (inlist.length === 1) {
                    inlist[0].bid_quantity += Number(curr_mat.bid_quantity.toFixed(8));
                    inlist[0].quantity += Number(curr_mat.quantity.toFixed(8));
                } else {
                    var one_found = 0;
                    _.each(inlist, function (mat) {
                        if (mat.note === curr_mat.note) {
                            inlist[0].bid_quantity += Number(curr_mat.bid_quantity.toFixed(8));
                            inlist[0].quantity += Number(curr_mat.quantity.toFixed(8));
                            one_found++;
                        }
                    });
                    if (one_found > 1) {
                        toaster.pop('error', 'Material Combining Error', 'Contact Admin');
                        return;
                    }
                }
            });
            return temp_list;
        };

        /**
         * @description add the isInventory Key
         * @author Atul
         */
        var getMaterialSuppliers = function (tasks) {
            var names = [];

            _.each(tasks, function (task) {
                _.each(task.materials, function (material) {
                    // var idx = names.indexOf(material.supplier)
                    var idx = $filter('filter')(names, {
                        'name': material.supplier,
                        'isInventory': material.isInventory
                    }, true)

                    if (idx.length === 0) {
                        names.push({ name: material.supplier, isInventory: material.isInventory });
                    }
                });
            });

            return names;
        };

        var getEquipmentSuppliers = function (tasks) {
            var names = [];

            _.each(tasks, function (task) {
                _.each(task.equipment, function (equipment) {
                    var idx = names.indexOf(equipment.supplier)

                    if (idx === -1) {
                        names.push(equipment.supplier);
                    }
                });
            });

            return names;
        };

        var getAllEmailContacts = function (contact) {
            var emails = [];

            _.each(contact.company_emails, function (email) {
                emails.push(email);
            });
            _.each(contact.material_suppliers, function (supplier) {
                _.each(supplier.emails, function (email) {
                    emails.push(email);
                });
            });
            _.each(contact.equipment_suppliers, function (supplier) {
                _.each(supplier.emails, function (email) {
                    emails.push(email);
                });
            });

            return emails;
        };

        var getCompanyEmailContacts = function (contact) {
            var emails = [];

            _.each(contact.company_emails, function (email) {
                emails.push(email);
            });

            return emails;
        };

        var getSupplierEmailContacts = function (list, supplier) {
            var emails = [];

            _.each(list, function (item) {
                if (item.name === supplier) {
                    _.each(item.emails, function (email) {
                        emails.push(email);
                    });
                }
            });

            return emails;
        };

        var consolidateOnForemanNotes = function (list, sales_tax, manually_entered) {
            var items = [];

            _.each(list, function (material) {
                var in_list = [];

                (material.foreman_note) ?
                    material.foreman_note = material.foreman_note.trim() : material.foreman_note = '';
                (material.color_code) ?
                    material.color_code = material.color_code.trim() : material.color_code = '';

                in_list = $filter('filter')(items, {
                    'name': material.name,
                    'foreman_note': material.foreman_note,
                    'color_code': material.color_code
                }, true);

                material.sub_total = material.quantity * material.price_per_order;
                material.sales_tax = material.sub_total * sales_tax;
                material.total = material.sub_total + material.sales_tax +
                    (material.delivery_price * material.quantity);

                if (in_list.length === 0) {
                    material.lots = [];
                    material.plans = [];
                    material.bid_notes = [];
                    material.lots.push({
                        name: material.lot
                    });
                    material.plans.push({
                        name: material.plan_code
                    });
                    material.bid_notes.push({
                        lot: material.lot,
                        note: material.bid_note
                    });

                    material.manually_entered = manually_entered;

                    items.push(angular.copy(material));
                } else if (in_list.length === 1) {

                    in_list[0].lots.push({
                        name: material.lot
                    });
                    in_list[0].plans.push({
                        name: material.plan_code
                    });
                    in_list[0].bid_notes.push({
                        lot: material.lot,
                        note: material.bid_note
                    });
                    if (in_list[0].bid_notes[0].note !== material.bid_note) {
                        in_list[0].bid_note = 'Multiple';
                    }

                    in_list[0].lot = 'Multiple';
                    in_list[0].plan_code = 'Multiple';
                    in_list[0].bid_quantity += material.bid_quantity;
                    in_list[0].quantity += Number(material.quantity.toFixed(8));
                    in_list[0].sub_total += Number(material.quantity.toFixed(8)) * material.price_per_order;
                } else {
                    alert('Too many of the same items in the consolidated list.  Contact Admin');
                    return;
                }
            });

            return items;
        }

        var consolidateEquipmentOnForemanNotes = function (list, equipment_tax) {
            var items = [];

            _.each(list, function (equipment) {
                var in_list = [];

                if (equipment.foreman_note) {
                    in_list = $filter('filter')(items,
                        { 'name': equipment.name, 'foreman_note': equipment.foreman_note }, true);
                } else {
                    equipment.foreman_note = '';
                    in_list = $filter('filter')(items,
                        { 'name': equipment.name, 'foreman_note': '' }, true);
                }

                var price = (equipment.price) ? equipment.price : equipment.price_per_order;

                equipment.sub_total = equipment.quantity * price;
                equipment.total = equipment.sub_total + (equipment.sub_total * equipment_tax) +
                    (equipment.delivery_price * equipment.quantity);

                if (in_list.length === 0) {
                    items.push(angular.copy(equipment));
                } else if (in_list.length === 1) {
                    in_list[0].lot = 'Multiple';
                    in_list[0].plan_code = 'Multiple';
                    in_list[0].bid_quantity += equipment.bid_quantity;
                    in_list[0].quantity += equipment.quantity;
                    in_list[0].sub_total += equipment.quantity * equipment.price_per_order;
                } else {
                    alert('Too many of the same items in the consolidated list.  Contact Admin');
                    return;
                }
            });

            return items;
        }

        var getConsolidatedBidTotal = function (list, sales_tax) {
            var total = 0;

            _.each(list, function (material) {
                var qty = material.bid_quantity;
                if (Number(material.bid_quantity.toFixed(8)) % 1 !== 0) {
                    qty = $window.Math.ceil(material.bid_quantity);
                }
                material.sub_total = qty * material.price_per_order;
                material.sales_tax = material.sub_total * sales_tax;
                total += material.sub_total + material.sales_tax +
                    (material.delivery_price * qty);
            });

            return total;
        }

        var getConsolidatedEquipmentBidTotal = function (list, equipment_tax) {
            var total = 0;

            _.each(list, function (equipment) {
                if (equipment.bid_quantity % 1 !== 0) {
                    equipment.bid_quantity = $window.Math.ceil(equipment.bid_quantity);
                }
                var price = (equipment.price) ? equipment.price : equipment.price_per_order;

                equipment.sub_total = equipment.bid_quantity * price;
                equipment.equipment_tax = equipment.sub_total * equipment_tax;
                total += equipment.sub_total + equipment.equipment_tax +
                    (equipment.delivery_price * equipment.bid_quantity);
            });

            return total;
        }

        var getConsolidatedActualTotal = function (list, sales_tax) {
            var total = 0;

            _.each(list, function (material) {
                //higher precision would be great but when dealing with
                //multiple lots and spreading the quantities out, we could
                //have numbers like 15.0000001411 or similar
                if (Number(material.quantity.toFixed(3)) % 1 !== 0) {
                    material.quantity = $window.Math.ceil(material.quantity);
                }
                material.sub_total = material.quantity * material.price_per_order;
                material.sales_tax = material.sub_total * sales_tax;
                material.total = material.sub_total + material.sales_tax +
                    (material.delivery_price * material.quantity);

                total += material.total;
            });

            return total;
        }

        var getConsolidatedEquipmentActualTotal = function (list, equipment_tax) {
            var total = 0;

            _.each(list, function (equipment) {
                if (Number(equipment.quantity.toFixed(3)) % 1 !== 0) {
                    equipment.quantity = $window.Math.ceil(equipment.quantity);
                }
                var price = (equipment.price) ? equipment.price : equipment.price_per_order;
                equipment.sub_total = equipment.quantity * price;
                equipment.equipment_tax = equipment.sub_total * equipment_tax;
                equipment.total = equipment.sub_total + equipment.equipment_tax +
                    (equipment.delivery_price * equipment.quantity);

                total += equipment.total;
            });

            return total;
        }

        var getMergableReports = function (report, list) {
            var mergable_reports = [];

            _.each(list, function (item) {
                //first...only fill the list with similar suppliers
                if (item.supplier === report.supplier) {
                    //make sure we don't list the current report
                    if (item.task_code !== report.task_code) {
                        //don't list a report that has already been merged
                        if (!item.merged && !item.submitted) {
                            var lot_str = '';
                            _.each(item.lots, function (lot, j) {
                                lot_str += lot.item;

                                if (j !== item.lots.length - 1) {
                                    lot_str += ', ';
                                }
                            });
                            item.lot_str = lot_str;
                            mergable_reports.push(item);
                        }
                    }
                }
            });

            return mergable_reports;
        }

        var lotsMatch = function (a, b) {
            if (a.length !== b.length) return false;

            _.each(a, function (item) {
                var inlist = $filter('filter')(b, { 'item': item.item }, true);

                if (inlist.length !== 1) return false;
            });

            return true;
        }

        return {
            setLotsTasks: setLotsTasks,
            removedMerged: removedMerged,
            removeZeroQuantityItems: removeZeroQuantityItems,
            pdfRemoveZeroQuantityItems: pdfRemoveZeroQuantityItems,
            combineSimilarItems: combineSimilarItems,
            combineSimilarNoteItems: combineSimilarNoteItems,
            combineSimilarNoteItemsNewArray: combineSimilarNoteItemsNewArray,
            getMaterialSuppliers: getMaterialSuppliers,
            getEquipmentSuppliers: getEquipmentSuppliers,
            getCompanyEmailContacts: getCompanyEmailContacts,
            getAllEmailContacts: getAllEmailContacts,
            getSupplierEmailContacts: getSupplierEmailContacts,
            consolidateOnForemanNotes: consolidateOnForemanNotes,
            consolidateEquipmentOnForemanNotes: consolidateEquipmentOnForemanNotes,
            getConsolidatedBidTotal: getConsolidatedBidTotal,
            getConsolidatedActualTotal: getConsolidatedActualTotal,
            getConsolidatedEquipmentBidTotal: getConsolidatedEquipmentBidTotal,
            getConsolidatedEquipmentActualTotal: getConsolidatedEquipmentActualTotal,
            getMergableReports: getMergableReports,
            lotsMatch: lotsMatch
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/services/foreman-phase-service.js